import {Brick, registerBrick, Service} from 'olympe';
import {SHARED_MEMORY_TOPICS} from '../../services/service_api/CreateAllRASharedMemory.brick';

export default class GetSharedMemoryStatus extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {!Array} inputs
     * @param {function()} forwardEvent
     * @param {function(string)} setBackendId
     * @param {function(TimeoutMap)} setCandexSessionId
     * @param {function(TimeoutMap)} setCXMLBuyerCookies
     * @param {function()} setNestBuyInfo
     * @param {function(Map)} setSystemAliasByUser
     */
    update($, inputs, [forwardEvent, setBackendId, setCandexSessionId, setCXMLBuyerCookies, setSystemAliasByUser, setNestBuyInfo]) {
        Service.get('allRaSharedMemory', {topic: SHARED_MEMORY_TOPICS.ALL_MEMORIES})
            .then((data) => {
                setBackendId(data.backendId);
                setCandexSessionId(data.candexSessionIds);
                setCXMLBuyerCookies(data.cxmlBuyerCookies);
                setSystemAliasByUser(data.systemAliasByUser);
                setNestBuyInfo(data.nestBuySessionInfo);
                forwardEvent();
            });
    }
}

registerBrick('019932e210e77297e555', GetSharedMemoryStatus);
